import { render, staticRenderFns } from "./MenuConfiguration.vue?vue&type=template&id=ca822d1c&scoped=true&"
import script from "./MenuConfiguration.vue?vue&type=script&lang=js&"
export * from "./MenuConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./MenuConfiguration.vue?vue&type=style&index=0&id=ca822d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca822d1c",
  null
  
)

export default component.exports